import { render, staticRenderFns } from "./OutpatientReviewMassUpdate.vue?vue&type=template&id=0011f5dd&"
import script from "./OutpatientReviewMassUpdate.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewMassUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports